import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import API from 'app/api';

// Async thunks
export const fetchSnackbar = createAsyncThunk(
  'snackbar/fetch',
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await API.get('/snackbar');
      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const snackbarSlice = createSlice({
  name: 'snackbar',
  initialState: {
    open: false,
    message: '',
    status: 'info',
    link: null,
    linkText: null,
  },
  reducers: {
    setSnackbar: (state, action) => {
      state.open = true;
      state.message = action.payload.message;
      state.status = action.payload.status;
      state.link = action.payload.link ?? null;
      state.linkText = action.payload.linkText ?? null;
    },
    clearSnackbar: (state) => {
      state.open = false;
      state.message = '';
      state.status = 'info';
      state.link = null;
      state.linkText = null;
    },
  },
});

export const { setSnackbar, clearSnackbar } = snackbarSlice.actions;
export default snackbarSlice.reducer;
